import Class from './c-card';
import './c-card@';

export default Class;